import { logger } from '@lusha/client-logger';
export class CacheRepository {
    static set(key, value, ttlInSeconds) {
        const currentTime = new Date().getTime();
        const item = {
            value,
            expiry: currentTime + ttlInSeconds * 1000, // Convert seconds to milliseconds
        };
        try {
            sessionStorage.setItem(key, JSON.stringify(item));
        }
        catch (error) {
            logger.error(`Error storing data for key: ${key}, error: ${error}`);
        }
    }
    static get(key) {
        try {
            const cachedItem = sessionStorage.getItem(key);
            if (cachedItem) {
                const parsedItem = JSON.parse(cachedItem);
                const currentTime = new Date().getTime();
                // Check if the item is expired
                if (parsedItem.expiry && currentTime > parsedItem.expiry) {
                    sessionStorage.removeItem(key);
                    return null;
                }
                return parsedItem.value;
            }
            return null;
        }
        catch (error) {
            logger.error(`Error retrieving data for key: ${key}, error: ${error}`);
            return null;
        }
    }
    static remove(key) {
        try {
            sessionStorage.removeItem(key);
        }
        catch (error) {
            logger.error(`Error removing data for key: ${key}, error: ${error} `);
        }
    }
}
